import plangridTrackEvents from "./amplitudeInit-vanilla";
import attachSidenavEvents from "../../pages/helpers/attachSidenavEvents";

const sideNavOptions = {
  filterElementsClass: 'project',
  initialFilter: 'All industries',
  seeMoreButtonClass: 'see-more-btn',
  paramOption: true,
};

const init = () => {
  plangridTrackEvents('projects');
  attachSidenavEvents(sideNavOptions);
};

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/assets/js/projects.js